export const teamMembers = [
  {
    name: 'Yang Jun',
    position: 'Lead Guide',
    image: '/images/team/member2.jpg'
  },
  {
    name: 'He Ying',
    position: 'Lead Guide',
    image: '/images/team/member4.jpg'
  },
  {
    name: 'Mu Su La',
    position: 'Founder',
    image: '/images/team/member1.jpg'
  },
  {
    name: 'Karen',
    position: 'Assistant',
    image: '/images/team/member3.jpg'
  },
  {
    name: 'Zhao Rui',
    position: 'Driver',
    image: '/images/team/member7.jpg'
  },
  {
    name: 'Anna',
    position: 'Marketing & Partnerships Manager',
    image: '/images/team/member6.jpg'
  },
  {
    name: 'He Ming',
    position: 'Travel Consulant',
    image: '/images/team/member5.jpg'
  },
  {
    name: 'He Zhijian',
    position: 'Lead Guide',
    image: '/images/team/member8.jpg'
  },
  {
    name: 'Eric',
    position: 'Lead Guide',
    image: '/images/team/member9.jpg'
  },
  {
    name: 'David',
    position: 'Travel Consulant',
    image: '/images/team/member10.jpg'
  },
  {
    name: 'Mr. Yang',
    position: 'Driver',
    image: '/images/team/driver1.jpg'
  },
  {
    name: 'Mr. Wang',
    position: 'Driver',
    image: '/images/team/driver2.jpg'
  },
  {
    name: 'Mr. Li',
    position: 'Driver',
    image: '/images/team/driver3.jpg'
  }
]; 